import Base from './base'
import urls from 'config/urls'

class RedEnvelope extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.redenvelope.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.redenvelope.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.redenvelope.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.redenvelope.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.redenvelope.delete,
      data: opts
    })
  }
  activate (opts) {
    return this.httpPost({
      url: urls.redenvelope.activate,
      data: opts
    })
  }
  clearFailed (opts) {
    return this.httpPost({
      url: urls.redenvelope.clearFailed,
      data: opts
    })
  }

  findOpen (opts) {
    return this.httpGet({
      url: urls.redenvelope.findOpen,
      data: opts
    })
  }

  exportOpen (opts) {
    return this.httpDownload({
      url: urls.redenvelope.exportOpen,
      data: opts
    })
  }

  findQRCode (opts) {
    return this.httpGet({
      url: urls.redenvelope.findQRCode,
      data: opts
    })
  }

  createQRCode (opts) {
    return this.httpPost({
      url: urls.redenvelope.createQRCode,
      data: opts
    })
  }

  deleteQRCode (opts) {
    return this.httpPost({
      url: urls.redenvelope.deleteQRCode,
      data: opts
    })
  }

  downloadQRCode (opts) {
    return this.httpDownload({
      url: urls.redenvelope.downloadQRCode,
      data: opts
    })
  }

  findCategory (opts) {
    return this.httpGet({
      url: urls.redenvelope.findCategory,
      data: opts
    })
  }

  createCategory (opts) {
    return this.httpPost({
      url: urls.redenvelope.createCategory,
      data: opts
    })
  }

  updateCategory (opts) {
    return this.httpPost({
      url: urls.redenvelope.updateCategory,
      data: opts
    })
  }

  deleteCategory (opts) {
    return this.httpPost({
      url: urls.redenvelope.deleteCategory,
      data: opts
    })
  }
}

export default new RedEnvelope



// WEBPACK FOOTER //
// ./src/models/redenvelope.js